<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
    </div>

    <span class="page-title">Device Models</span>
    @if (ModelFirmwareCreate) {
      <div class="button-group">
        <button class="primary-button" (click)="AddNew()">
          Add Device Model <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      </div>
    }
  </div>

  @if (ModelFirmwareView) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Device Models List</h6>
        <div class="component-actions">
          <app-common-search
            (searchSubmit)="onSearchInputChange($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Model Code</th>
              <th>Model Name</th>
              <th>Model Serial Sequence</th>
              <th>Hardware Version</th>
              <!-- <th>Status Updated On</th> -->
              @if (ModelFirmwareView || ModelFirmwareDelete) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (modelList.length > 0) {
            <tbody>
              @for (
                item of modelList
                  | paginate
                    : {
                        id: 'batchpaginate',
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.modelCode }}</td>
                  <td>{{ item.modelName }}</td>
                  <td>{{ item.modelSerialSequence }}</td>
                  <td>{{ item.hardwareVersion }}</td>
                  <td>
                    <div class="action-buttons">
                      @if (ModelFirmwareView && item.status !== 'N') {
                        <button
                          class="primary-button view-button"
                          (click)="prePopulation(item.modelId)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (ModelFirmwareDelete && item.status !== 'N') {
                        <button
                          class="primary-button delete-button"
                          (click)="delete(item.modelId)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (modelList.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <div class="component-footer">
        @if (modelList.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
